import { ContextMenuButton, Td, Tr } from 'app/components/Table';
import { format } from 'date-fns';
import { dateFormats } from 'app/constants';
import { MouseEvent } from 'react';
import { ListItemAvatar, ListItemText } from 'app/components/ChakraTableList';
import { getAvatarImage } from 'app/utils/utils';
import { Collaborator, CollaboratorStatus } from 'types/collaborator.types';
import { AppDispatch } from 'app/store';
import { Tooltip, Text } from '@chakra-ui/react';
import { setProfileBarSettings } from 'app/store/Settings/slice';
import { invitedBySecondarySx, nameSecondarySx } from './styles';

interface CollaboratorRowProps {
  collaborator: Collaborator;
  dispatch: AppDispatch;
  contextHandler?: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
}

export const CollaboratorRow = ({
  collaborator,
  dispatch,
  contextHandler,
}: CollaboratorRowProps) => {
  const isInvitePending = (collaborator: Collaborator) =>
    collaborator.status === CollaboratorStatus.PENDING;

  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      onContextMenu={contextHandler}
      onMouseDown={(e) => e.preventDefault()}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        <ListItemAvatar
          src={getAvatarImage(collaborator.profile?.profileImages)}
          initials={collaborator?.profileCard?.initials}
          colors={collaborator.profileCard?.avatarColors}
          {...(collaborator.profile
            ? {
                onClick: () => {
                  dispatch(setProfileBarSettings({ collaborator }));
                },
                cursor: 'pointer',
              }
            : {})}
        />
      </Td>
      <Td sx={{ pl: 0 }} data-testid="name">
        <ListItemText
          data-testid="collaborator-display-name"
          title={
            collaborator?.profile?.displayName ||
            collaborator?.inviteeEmail ||
            ''
          }
          primary={
            collaborator?.profile?.displayName ||
            collaborator?.inviteeEmail ||
            ''
          }
          secondary={
            isInvitePending(collaborator) ? (
              <Tooltip
                title={format(
                  new Date(collaborator?.created?.iso || 0),
                  dateFormats.LIST_FORMAT
                )}
              >
                <Text data-testid="invite-pending" {...nameSecondarySx}>
                  Invite Pending
                </Text>
              </Tooltip>
            ) : undefined
          }
        />
      </Td>
      <Td data-testid="invitedBy">
        <ListItemText
          data-testid="collaborator-invited-by"
          title={
            collaborator.invitedBy
              ? collaborator.invitedBy.profileCard.displayName
              : '-'
          }
          primary={
            collaborator.invitedBy
              ? collaborator.invitedBy.profileCard.displayName
              : '-'
          }
          secondaryTextProps={{
            'data-testid': 'collaborator-invited-by-date',
            ...invitedBySecondarySx,
          }}
          secondary={
            collaborator.invitedBy
              ? format(
                  collaborator.created.timestamp * 1000,
                  dateFormats.LIST_FORMAT
                )
              : ''
          }
        />
      </Td>
      <Td className="gap" />
      <Td>
        {contextHandler && <ContextMenuButton onClick={contextHandler} />}
      </Td>
    </Tr>
  );
};
